import { Add as AddIcon, Delete as DeleteIcon, Edit as EditIcon } from "@mui/icons-material";
import { Box } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import MicrospecDataTable, { MicrospecDataTableColumn } from "../../../../MicrospecDynamicUI/Components/DataTable/MicrospecFirestoreDataTable";
import { useMicrospecDynamicUIContext } from "../../../../MicrospecDynamicUI/GlobalProvider";
import { deleteDocumentById } from "../../../../MicrospecDynamicUI/Helpers/dataUtils";
import { useMicrospecThemeLanguageContext } from "../../../../MicrospecDynamicUI/Themes";
import { SPECIFICATION_CATEGORIES_COLLECTION, SPECIFICATIONS_COLLECTION } from "../../../constants/collectionPaths";

const SpecificationCategoriesManagementPage: React.FC = () => {
    const navigate = useNavigate();
    const { translate } = useMicrospecThemeLanguageContext().localizationProvider;
    const { cloudProvider } = useMicrospecDynamicUIContext();
    const { firestore, userProfile } = cloudProvider;
    const { getEntitiesRelationsCount } = userProfile.methods;
    const db = firestore?.instance;
    const t = translate;
    const [refreshKey, setRefreshKey] = useState(0);

    const columns: MicrospecDataTableColumn[] = [
        {
            field: 'name',
            headerName: t('specCategory.name'),
            sortable: true,
            minWidth: 220,
            align: 'left',
            render: (value: string | { [locale: string]: string }) => typeof value === 'string' ? value : translate(value),
        },
        {
            field: 'description',
            headerName: t('specCategory.description'),
            sortable: false,
            minWidth: 300,
            align: 'left',
            render: (value: string | { [locale: string]: string }) => {
                if (!value) return '-';
                return typeof value === 'string' ? value : translate(value);
            },
        },
    ];

    const handleDelete = async (row: any) => {
        if (!db) return;
        await getEntitiesRelationsCount([
            { parentEntityId: row.id, childEntityCollection: SPECIFICATIONS_COLLECTION, childFieldName: 'specification_category_id' },
        ]).then(async (response: { results: { count: number }[] }) => {
            if (response.results[0].count > 0) {
                alert(t('specCategory.hasSpecifications'));
                return;
            }
            if (window.confirm(t('specCategory.confirmDelete'))) {
                try {
                    await deleteDocumentById(db, SPECIFICATION_CATEGORIES_COLLECTION, row.id);
                    setRefreshKey(prev => prev + 1);
                } catch (error: unknown) {
                    alert(t('specCategory.deleteFailed'));
                }
            }
        }).catch(() => {
            alert(t('specCategory.deleteFailed'));
        });
    };

    return (
        <Box sx={{ width: '100%', p: 2 }}>
            <MicrospecDataTable
                key={refreshKey}
                collection={SPECIFICATION_CATEGORIES_COLLECTION}
                columns={columns}
                title={t('common.specificationCategories')}
                subtitle={t('specCategory.manageDescription')}
                searchable={true}
                exportable={true}
                refreshable={true}
                pageSize={25}
                maxHeight={700}
                onRowClick={(row) => navigate(`/manager/specification-categories/update/${row.id}`)}
                actions={[
                    { icon: <EditIcon />, label: t('common.edit'), onClick: (row) => navigate(`/manager/specification-categories/update/${row.id}`) },
                    { icon: <DeleteIcon />, label: t('common.delete'), onClick: handleDelete },
                ]}
                globalActions={[
                    { icon: <AddIcon />, label: t('common.addSpecificationCategory'), onClick: () => navigate('/manager/specification-categories/add'), variant: 'contained', color: 'primary' },
                ]}
            />
        </Box>
    );
};

export default SpecificationCategoriesManagementPage;
